import React from "react";

type Props = {
  outline: string | undefined;
};

const ImageOutline: React.FC<Props> = ({ outline }) => {
  return outline ? (
    <img className="image-outline" alt="outline" src={outline} />
  ) : (
    <></>
  );
};

export default ImageOutline;
